module.exports = __webpack_public_path__ + "media/images/baslow4-9aa63cbf1ace8c6cb779bd91a3d42f77.jpg";